<template>
  <div class="page-container" v-if="currentNews && currentNews.title">
    <h1 class="page-title">{{ currentNews.title }}</h1>
    <p class="page-date" v-if="currentNews.date">{{ currentNews.date }}</p>
    <div class="content">
      <template v-for="(section, index) in contentSections" :key="index">
        <div class="content-section">
          <div class="text-block">
            <p v-html="section"></p>
          </div>
        </div>
        <!-- Insert image 1 and 2 side by side after the first paragraph -->
        <div v-if="index === 0 && ((currentNews as any).other?.picture1 || (currentNews as any).other?.picture2)" class="content-section image-section image-row">
          <div v-if="(currentNews as any).other?.picture1" class="image-container half-width">
            <img :src="(currentNews as any).other.picture1.url" :alt="(currentNews as any).other.picture1.caption">
          </div>
          <div v-if="(currentNews as any).other?.picture2" class="image-container half-width">
            <img :src="(currentNews as any).other.picture2.url" :alt="(currentNews as any).other.picture2.caption">
          </div>
          <p v-if="(currentNews as any).other.picture1.caption" class="image-caption full-width">{{ (currentNews as any).other.picture1.caption }}</p>
        </div>
        <!-- Insert image 3 after the fifth paragraph -->
        <div v-if="index === 4 && (currentNews as any).other?.picture3" class="content-section image-section">
          <div class="image-container">
            <img :src="(currentNews as any).other.picture3.url" :alt="(currentNews as any).other.picture3.caption">
            <p v-if="(currentNews as any).other.picture3.caption" class="image-caption">{{ (currentNews as any).other.picture3.caption }}</p>
          </div>
        </div>
      </template>
    </div>
  </div>
  <div v-else class="page-container">
    <p>新闻内容未找到</p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useLangStore } from '../../../pinia/stores/lang';
import zhData from '../../../i18n/zh';
import enData from '../../../i18n/en';

const langStore = useLangStore();

const currentNews = computed(() => {
  const translationData = langStore.currentLang.startsWith('zh') ? zhData : enData;
  const newsList = translationData.pages.news.company.news.list;
  const newsItem = newsList.find((news: any) => news.id === 'zizhibacai300');
  return newsItem || {};
});

const contentSections = computed(() => {
  const content = (currentNews.value as any)?.content || '';
  return content ? content.split('---').filter((p: string) => p.trim()) : [];
});
</script>

<style scoped>
.page-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  font-family: 'Microsoft YaHei', Arial, sans-serif;
}

.page-title {
  font-size: 28px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
  line-height: 1.4;
}

.page-date {
  color: #666;
  font-size: 14px;
  margin-bottom: 30px;
}

.content {
  line-height: 1.8;
  color: #444;
}

.content-section {
  margin-bottom: 20px;
}

.text-block p {
  margin-bottom: 15px;
  text-align: justify;
  font-size: 16px;
}

.image-section {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 20px;
  margin-bottom: 20px;
}

.image-row {
  gap: 20px;
}

.image-container {
  width: 80%;
  text-align: center;
}

.image-container.half-width {
  width: 45%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.image-container img {
  width: 100%;
  border-radius: 4px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.image-caption {
  margin-top: 8px;
  text-align: center;
  font-size: 14px;
  color: #666;
}

.image-caption.full-width {
  width: 100%;
}
</style>
